import { useIsSparkSupported } from '../../context/edition';
import { TEAM_TABS } from './types';

export const TEAM_TAB_LABELS = {
  [TEAM_TABS.basic]: 'Basic Info',
  [TEAM_TABS.executionMetrics]: 'Execution Metrics'
};

export const useTeamSteps = () => {
  const isSparkSupported = useIsSparkSupported();
  return [
    {
      key: TEAM_TABS.basic,
      label: TEAM_TAB_LABELS[TEAM_TABS.basic]
    },
    isSparkSupported && {
      key: TEAM_TABS.executionMetrics,
      label: TEAM_TAB_LABELS[TEAM_TABS.executionMetrics]
    }
  ].filter(Boolean);
};
